var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_vm._v(" "+_vm._s(_vm.item.name)+" ")]),_c('td',[(
        _vm.$userCheckAccess({
          abilities: 'edit_work_extra_types',
        })
      )?_c('div',{staticClass:"buttons"},[_c('WorkExtraTypeModal',{attrs:{"create":false,"id":_vm.item.id}}),_c('DeleteModal',{attrs:{"item":_vm.item,"type":"workExtraType","text":_vm.localStorage.translations.pages['setting-work_extra_type']['dialog-delete'][
            'udalit-vid-dopolnitelnoy-raboty'
          ] +
          ' ' +
          _vm.item.name}})],1):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }